import { Injectable } from '@angular/core';

@Injectable()
export class SpinnerService {
  private requestCount = 0;
  private delayTimeout: any;
  private currentMaxDelay = 0;
  private loading: boolean;

  constructor() { }

  start() {
    if (this.requestCount === 0) {
      this.showSpinner();
    }
    this.requestCount++;
  }

  finish(delay: number = 0) {
    this.requestCount--;

    // Atualiza o delay atual apenas se o novo delay for maior
    if (delay > this.currentMaxDelay) {
      this.currentMaxDelay = delay;
    }

    // Finaliza o spinner somente se não houver mais requisições ativas
    if (this.requestCount <= 0) {
      clearTimeout(this.delayTimeout);
      this.delayTimeout = setTimeout(() => {
        if (this.requestCount <= 0) {
          this.hideSpinner();
        }
        this.currentMaxDelay = 0; // Reset the delay tracker after finishing
      }, this.currentMaxDelay);
    }
  }

  private showSpinner() {
    this.loading = true;
  }

  private hideSpinner() {
    this.loading = false;
  }

  getStatus(): boolean {
    return this.loading;
  }
}
